module.exports = __webpack_public_path__ + "img/49_BF27_make_arrangements.2a8f4aff.jpg";